import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid, Typography, Card, CardContent } from '@mui/material';

const IRSFormsLanding: React.FC = () => {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  return (
    <Grid container paddingLeft={2} paddingRight={2}>
      <Grid item xs={12} padding={1} textAlign="center">
        <Typography variant="h4" color="primary">
          IRS Forms
        </Typography>
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ mt: 2, mb: 4 }}
        >
          Select the type of forms you want to manage
        </Typography>
      </Grid>

      <Grid container spacing={3} justifyContent="center">
        <Grid item xs={12} sm={6} md={4}>
          <Card
            sx={{
              cursor: 'pointer',
              height: '100%',
              transition: 'transform 0.2s, box-shadow 0.2s',
              '&:hover': {
                transform: 'translateY(-4px)',
                boxShadow: 6,
              },
            }}
            onClick={() =>
              navigate(
                `/annual-reports/irs-forms/${currentYear}/local-chapters`
              )
            }
          >
            <CardContent sx={{ p: 4, textAlign: 'center' }}>
              <Typography variant="h5" color="primary" gutterBottom>
                Local Chapter Forms
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                Complete, review or approve IRS-LC.
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Card
            sx={{
              cursor: 'pointer',
              height: '100%',
              transition: 'transform 0.2s, box-shadow 0.2s',
              '&:hover': {
                transform: 'translateY(-4px)',
                boxShadow: 6,
              },
            }}
            onClick={() =>
              navigate(`/annual-reports/irs-forms/${currentYear}/spd`)
            }
          >
            <CardContent sx={{ p: 4, textAlign: 'center' }}>
              <Typography variant="h5" color="primary" gutterBottom>
                S/P/D Forms
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                Complete, review or approve IRS-SC.
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Card
            sx={{
              cursor: 'pointer',
              height: '100%',
              transition: 'transform 0.2s, box-shadow 0.2s',
              '&:hover': {
                transform: 'translateY(-4px)',
                boxShadow: 6,
              },
            }}
            onClick={() =>
              navigate(`/annual-reports/irs-forms/${currentYear}/reciprocity`)
            }
          >
            <CardContent sx={{ p: 4, textAlign: 'center' }}>
              <Typography variant="h5" color="primary" gutterBottom>
                Reciprocity Forms
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                Complete, review or approve IRS-RG for reciprocities/groups
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default IRSFormsLanding;
